export default __webpack_public_path__ + "static/media/Front-Villa-Ahmad-Achour-in-Syria.e322b38c.jpg";